import { __assign, __extends } from "tslib";
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { CommonWrapper } from '@skbkontur/react-ui/internal/CommonWrapper';
import { ThemeContext } from '@skbkontur/react-ui/lib/theming/ThemeContext';
import { ArrowChevronDownIcon as ArrowChevronDown } from '@skbkontur/react-ui/internal/icons/16px';
import { isIE11 } from '@skbkontur/react-ui/lib/client';
import { getAddonsTheme } from '../../lib/theming/ThemeHelpers';
import { jsStyles } from './Logotype.styles';
import { ProductWidget } from './ProductWidget';
var DEFAULT_LOGO_SIZE = 24;
var Logotype = /** @class */ (function (_super) {
    __extends(Logotype, _super);
    function Logotype() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isWidgetInited = false;
        _this.getSize = function () {
            var _a;
            return _a = _this.props.size, (_a !== null && _a !== void 0 ? _a : DEFAULT_LOGO_SIZE);
        };
        _this.renderLogo = function () {
            var _a = _this.props, konturLogo = _a.konturLogo, productLogo = _a.productLogo;
            var size = _this.getSize();
            return (React.createElement(React.Fragment, null,
                React.createElement("span", { className: jsStyles.konturLogo() }, konturLogo && React.cloneElement(konturLogo, { size: size })),
                productLogo && React.createElement("span", { className: jsStyles.productLogo() }, React.cloneElement(productLogo, { size: size }))));
        };
        _this.initWidget = function () {
            if (!_this.isWidgetInited) {
                ProductWidget.init();
                _this.isWidgetInited = true;
            }
        };
        return _this;
    }
    Logotype.prototype.componentDidMount = function () {
        if (this.props.withWidget) {
            this.initWidget();
        }
    };
    Logotype.prototype.componentDidUpdate = function () {
        if (this.props.withWidget) {
            this.initWidget();
        }
    };
    Logotype.prototype.render = function () {
        var _this = this;
        return (React.createElement(ThemeContext.Consumer, null, function (theme) {
            _this.theme = getAddonsTheme(theme);
            return _this.renderMain();
        }));
    };
    Logotype.prototype.renderMain = function () {
        var _a, _b;
        var _c = this.props, Component = _c.component, href = _c.href, withWidget = _c.withWidget, onArrowClick = _c.onArrowClick, onClick = _c.onClick;
        var size = this.getSize();
        var componentClassName = jsStyles.root();
        var dividerClassName = jsStyles.divider(this.theme);
        var buttonClassName = cn(jsStyles.button(this.theme), (_a = {},
            _a[jsStyles.buttonIE11Fallback()] = isIE11,
            _a));
        var styleComponent = { height: size };
        var logo = this.renderLogo();
        var dropdownClassName = cn(jsStyles.dropdown(), (_b = {},
            _b[jsStyles.inline()] = !withWidget,
            _b));
        var component = (React.createElement(Component, { href: href, tabIndex: "-1", onClick: onClick, className: componentClassName, style: styleComponent, "data-logotype-component": true }, logo));
        return (React.createElement(CommonWrapper, __assign({}, this.props),
            React.createElement("div", { id: "spwDropdown", className: dropdownClassName },
                React.createElement("span", { className: jsStyles.widgetWrapper() },
                    component,
                    withWidget && React.createElement("span", { className: dividerClassName })),
                withWidget && (React.createElement("button", { id: "spwClicker", className: buttonClassName, onClick: onArrowClick },
                    React.createElement(ArrowChevronDown, { color: "#aaa", size: 20 }))))));
    };
    Logotype.__KONTUR_REACT_UI__ = 'Logotype';
    Logotype.propTypes = {
        href: PropTypes.string,
        size: PropTypes.number,
        withWidget: PropTypes.bool,
    };
    Logotype.defaultProps = {
        component: 'a',
        href: '/',
        konturLogo: null,
        productLogo: null,
    };
    return Logotype;
}(React.Component));
export { Logotype };
